import style from "./style.module.scss";
import editImg from '../ConfirmationNumber/Edit.png';
import arrowImg from '../Arrow.png';
import mobileImg from "../loginPage/mobile.png";
import { useEffect, useRef, useState } from "react";
import { fancyTimeFormat } from "../../../../../Panel/Common/Function";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { verifyCodeNewPassword, ResendVerifyCode } from "../../../../../Web/View/Auth/Components/Services";
import { toast } from "react-hot-toast";
const ForgetPassword = ({ step, setStep, isLogin, setisLogin, isWebview }) => {

    const [CodeSms, setCodeSms] = useState([null, null, null, null, null]);
    const [Code, setCode] = useState([null, null, null, null, null]);
    const [Timer, setTimer] = useState(120);
    const { mobile } = useSelector(state => state);
    const location = useLocation();
    const dispatch = useDispatch();
    let initialState = {
        mobile: location.state ? location.state.mobile : mobile,
        veryfyCode: null,
        NewPass: null,
        ReNewPass: null
    }
    const [state, setState] = useState(initialState);
    useEffect(() => {
        ref1.current.focus();
    }, [])

    const TimerCode = () => {
        setTimeout(() => {
            if (Timer >= 1) {
                setTimer(Timer - 1)
            }
        }, 1000);
    }

    TimerCode();

    const CodeHandel = (mobile, password, veryfyCode) => {

        if (state.NewPass === null || state.ReNewPass === null) {
            toast.error("لطفا رمز خود را وارد کنید")
        }
        else if (state.NewPass !== state.ReNewPass) {
            toast.error("مقادیر ورودی یکسان نمی باشد")
        }
        else if (state.veryfyCode !== null && state.NewPass === state.ReNewPass) {
            verifyCodeNewPassword(mobile, password, veryfyCode).then(result => {
                if (typeof result === "object") {
                    localStorage.removeItem("user");
                    dispatch({
                        local_storage: {
                            key: "user",
                            value: result,
                        },
                        type: "SET",
                        payload: { user: result },
                    });
                    dispatch({
                        local_storage: {
                            key: "user_type",
                            value: result.role,
                        },
                        type: "SET",
                        payload: { user_type: result.role },
                    });
                    if (result.status === "active") {
                        if (isWebview) {
                            setisLogin(true)
                        }
                        else {
                            location.reload();
                        }
                    }
                }
            });
        }
    }

    const ResendCodeHandel = (mobile) => {
        ResendVerifyCode(mobile).then(result => {
            setState({
                ...state,
                result: result
            })
        })
    }

    const ref1 = useRef();
    const ref2 = useRef();
    const ref3 = useRef();
    const ref4 = useRef();
    const ref5 = useRef();
    const refPass = useRef();

    const SmsHandler = (e, index, ref) => {
        let NewData = CodeSms;
        NewData[index] = e.target.value;
        setCodeSms(NewData);
        setCode(NewData);
        setState(() => ({ ...state, veryfyCode: Code.join("") }))
        e.target.value &&
            ref != "r5" ? ref.current.focus() : ref4.current.blur()
    }
    const resetTimer = () => {
        ResendCodeHandel(state.mobile);
        setTimer(() => 120)
    }
    return (
        <>
            <section>
                <div className={style.headText}>
                    <img src={arrowImg} onClick={() => setStep("step3")} className={style.arrowIcon} alt="arrowIcon" />
                    <h3 className={style.titelText}>تایید شماره همراه</h3>
                </div>
                <div>
                    <p className={style.warn}>لطفا کد 5 رقمی که برای شما ارسال شده است را وارد نمایید.</p>
                    <div className={style.boxEdit}>
                        <div className={style.boxNumber}>
                            <img src={mobileImg} className={style.mobileIcon} alt="mobileIcon" />
                            <p >{mobile}</p>
                        </div>
                        <img src={editImg} onClick={() => setStep("step2")} className={style.editIcon} alt="editIcon" />
                    </div>
                    <div className={style.parentInput}>
                        <input ref={ref1} maxLength={1} onChange={(e) => SmsHandler(e, 0, ref2)} className={style.input} type="number" />
                        <input ref={ref2} maxLength={1} onChange={(e) => SmsHandler(e, 1, ref3)} className={style.input} type="number" />
                        <input ref={ref3} maxLength={1} onChange={(e) => SmsHandler(e, 2, ref4)} className={style.input} type="number" />
                        <input ref={ref4} maxLength={1} onChange={(e) => SmsHandler(e, 3, ref5)} className={style.input} type="number" />
                        <input ref={ref5} maxLength={1} onChange={(e) => SmsHandler(e, 4, "r5")} className={style.input} type="number" />
                    </div>
                    {
                        Timer > 0 ?
                            <p className={style.showTime}> زمان باقی مانده : {fancyTimeFormat(Timer)}</p>
                            :
                            <p className={style.showTime} onClick={() => resetTimer()} >ارسال مجدد کد</p>
                    }

                    <div className="d-flex justify-content-center">
                        <div className="">
                            <div className={style.parentInputLogin}>
                                <input className={style.inputLogin} type="password" ref={refPass} onChange={(e) => setState({ ...state, NewPass: e.target.value })} name="password" placeholder="رمز عبور جدید" id="password" />
                            </div>
                            <div className={style.parentInputLogin}>
                                <input className={style.inputLogin} type="password" onChange={(e) => setState({ ...state, ReNewPass: e.target.value })} name="Repassword" placeholder=" تکرار رمز عبور" id="Repassword" />
                            </div>
                            <button
                                className={style.btn} style={{ background: Timer < 1 ? 'gray' : '#E42A3F' }}
                                // disabled={Timer < 1 ? "disabled" : null} 
                                onClick={() => CodeHandel(state.mobile, state.ReNewPass, state.veryfyCode)}
                            >ثبت رمز عبور</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ForgetPassword;